import { render, staticRenderFns } from "./TaskVisitLinkFields.vue?vue&type=template&id=2b1d39b3&"
import script from "./TaskVisitLinkFields.vue?vue&type=script&lang=js&"
export * from "./TaskVisitLinkFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports